import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  voices: [],
};

export const voicesSlice = createSlice({
  name: "voices",
  initialState: { ...initialState },

  reducers: {
    /**
     * @name @setNotesToState
     * @description set notes to state
     **/
    setVoicesToState: (state, action) => {
      if (action?.payload) state.voices = [...action?.payload];
    },
    /**
     * @name @setNoteToState
     * @description set a note to state
     **/
    setVoiceToState: (state, action) => {
      const voicesState = JSON.parse(JSON.stringify(state.voices));
      voicesState.unshift(action.payload);
      state.voices = [...voicesState];
    },
    /**
     * @name @setUpdatedVoiceToState
     * @description set an updated Voice to state
     **/
    setUpdatedVoiceToState: (state, action) => {
      let voicesState = JSON.parse(JSON.stringify(state.voices));
      voicesState = voicesState.map((note) => {
        if (note.id === action.payload?.id) {
          note.note = action.payload?.note;
        }
        return note;
      });
      state.voices = [...voicesState];
    },
  },
});

export const { setVoicesToState, setVoiceToState, setUpdatedVoiceToState } =
  voicesSlice.actions;

export const getVoices = (state) => {
  return state.voices?.voices;
};

export default voicesSlice.reducer;
